/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class t{constructor(){this.name=this.constructor.name}createOptions(t,r){return null}}export{t as Effect};
